import type { BranchData, EatigoOrderListData, EatigoOrderOrderData } from '@/types/api'
import type { SlotInfo } from '@/types/product'

function createContextMissingMessage(providerName: string) {
  return `Context missing. Please verify this component is nested within the ${providerName}.`
}

const BRANCH_DETAIL_CONTEXT_KEY = 'branchDetailContext'

type BranchDetailContext = {
  branch: ReadonlyRef<Nullable<BranchData>>
  attendance: Ref<number>
  date: Ref<Nullable<string>>
  slotInfo: Ref<Nullable<SlotInfo>>
  isSoldOut: ReadonlyRef<boolean>
}

export function useBranchDetailProvider(context: BranchDetailContext) {
  provide(BRANCH_DETAIL_CONTEXT_KEY, context)
}

export function useBranchDetailContext() {
  const context = inject<BranchDetailContext>(BRANCH_DETAIL_CONTEXT_KEY)

  if (!context) {
    throw new Error(createContextMissingMessage('BranchDetailProvider'))
  }

  return context
}

const ORDER_CONTEXT_KEY = 'orderContext'

type OrderContext = {
  order: Ref<EatigoOrderListData & EatigoOrderOrderData>
  isOrderDetailFetching?: ReadonlyRef<boolean>
  refreshOrderDetail?: () => Promise<void>
}

export function useOrderProvider(context: OrderContext) {
  provide(ORDER_CONTEXT_KEY, context)
}

export function useOrderContext() {
  const context = inject<OrderContext>(ORDER_CONTEXT_KEY)

  if (!context) {
    throw new Error(createContextMissingMessage('OrderCardProvider'))
  }

  return context
}
